import md5 from 'blueimp-md5';
import isEmail from 'validator/lib/isEmail';

import {DATALAYER_EMAIL} from 'constants/analytics';
import {sessionStore} from 'libs/storage/storage';

/**
 * Push data info GTM
 * @param {string} event Current event name
 * @param {boolean} isRaw enables sending event as object
 * @deprecated
 */
function analytics(event: string | object, isRaw = false) {
    window.dataLayer = window.dataLayer || [];
    const data = isRaw ? event : {event};
    window.dataLayer.push(data);
}

// TODO: Need to add shared pushDataLayer for using in mobile and desktop
/**
 * Send correct email to dataLayer.
 * @param {string} email - Email.
 */
export function sendEmailToDataLayer(email: string) {
    const isValidEmail = isEmail(email);
    if (!isValidEmail) return;
    const emailList: string[] = sessionStore.get(DATALAYER_EMAIL, []);
    const isNewEmail = !emailList.find(emailItem => emailItem === email);
    if (!isNewEmail) return;
    sessionStore.set(DATALAYER_EMAIL, [...emailList, email]);
    const hashedEmail = md5(email.trim().toLowerCase());
    analytics(
        {
            mktg_email: email,
            mktg_hashed_email: hashedEmail,
        },
        true,
    );
}
